<template>
  <v-card flat>
    <v-card-title>Övrigt</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            :items="items"
            item-value="data"
            :value-comparator="valueComparator"
            item-text="_text"
            outlined
            label="Övrigt"
            v-model="model.other_information"
            item-disabled="hidden"
            multiple
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click:close="remove(data.item)"
              >
                {{ data.item._text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <template v-if="searchParameters">
        <template v-for="(otherInfo, $i) in model.other_information">
          <v-container :key="$i">
            <v-row>
              <v-col>
                {{ getDescription(otherInfo.code) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col v-for="param in otherInfo.parameters" :key="param.name">
                <template v-if="getParam(param.name).autocompleteList.length">
                  <v-autocomplete
                    :items="getParam(param.name).autocompleteList"
                    v-model="param.value"
                    :placeholder="'Välj ' + param.name"
                    :hint="getParam(param.name).description"
                    :rules="[
                      required,
                      v =>
                        !!new RegExp(getParam(param.name).regex).test(v) ||
                        'Ogiltig'
                    ]"
                    outlined
                    :label="param.name"
                  />
                </template>
                <v-text-field
                  v-else
                  :label="param.name"
                  outlined
                  v-model="param.value"
                  :hint="getParam(param.name).description"
                  :rules="[
                    required,
                    v =>
                      !!new RegExp(getParam(param.name).regex).test(v) ||
                      'Ogiltig'
                  ]"
                />
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-container>
        </template>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from '@/common/validationRules'
import { get } from 'vuex-pathify'
import SEARCH_PARAMETERS from '../../graphql/searchParameters'

export default {
  name: 'DuwaOtherInformation',

  props: {
    codes: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    required,
    model: {
      other_information: []
    }
  }),

  apollo: {
    searchParameters: {
      query: SEARCH_PARAMETERS,
      fetchPolicy: 'no-cache'
    }
  },

  created() {
    this.model.other_information = this.currentOtherInformation.slice()
  },

  watch: {
    'model.other_information'(value) {
      this.$store.set(
        'duwa/payload',
        this.payload.map(x => ({
          ...x,
          other: {
            ...x.other,
            after: value
          }
        }))
      )
    }
  },

  computed: {
    payload: get('duwa/payload'),
    currentOtherInformation: get('duwa/currentOtherInformation'),
    stops: get('duwa/stops'),

    items() {
      return this.codes
        .filter(x => x.category === 'other')
        .map(x => {
          if (x.text_43_characters) {
            x._text = x.text_43_characters
          } else if (x.text_13_characters) {
            x._text = x.text_13_characters
          } else if (x.text_9_characters) {
            x._text = x.text_9_characters
          }
          x.data = {
            parameters: (x.parameters || []).map(({ name, value }) => ({
              name,
              value
            })),
            code: x.code
          }
          return x
        })
        .filter(
          x =>
            !x.hidden ||
            this.currentOtherInformation.some(({ code }) => code === x.code)
        )
    }
  },

  methods: {
    getParam(attribute) {
      return (this.searchParameters || []).find(
        x => x.attribute === attribute.toLowerCase()
      )
    },

    valueComparator(a, b) {
      if (!a || !b) return false
      const transformB = Array.isArray(b) ? b : [b]
      return transformB.some(x => x.code === a.code)
    },
    getDescription(code) {
      return this.items.find(x => x.code === code)._text
    },

    isDisabled(code) {
      return this.items.find(x => x.code === code).hidden
    },

    remove(item) {
      const index = this.model.other_information.findIndex(
        x => x.code === item.code
      )
      if (index >= 0) this.model.other_information.splice(index, 1)
    }
  }
}
</script>
